export const scrollElementToTop = (element: HTMLDivElement | Window | null, animated = true) => {
    if (!element) {
        return;
    }
    if (!animated && element['scrollTop']) {
        element['scrollTop'] = 0;

        return;
    }
    setTimeout(() =>
        element.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        }),
    );
};

export const scrollWindowToTop = scrollElementToTop.bind(null, window, true);
